import { UserAttributeDefs, ValidModelType } from "@iotv/datamodel-core";
import { PathDirection, ValidBusinessObject } from "@iotv/iotv-v3-types";
import { Storage as V020Storage } from "./Storage";

const typeName = "Dam";

export type DamProps = {
  purpose?: string;
  capacity?: number;
  currentVolume?: number;
  diameter?: number;
  depth?: number;
  floorSize?: number;
  topArea?: number;
  constructionMaterial?: string;
  image?: string;
  surfaceWidth?: number;
  bottomWidth?: number;
  surfaceLength?: number;
  bottomLength?: number;
};

export class Dam extends V020Storage {
  constructor(ob: ValidBusinessObject) {
    super({ ...ob, typeName });
  }

  diameter?: number;
  depth?: number;
  floorSize?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: "String",
        editable: true,
        label: "Name",
        name: "name",
        description: "Name of dam",
      },
      purpose: {
        type: "String",
        editable: true,
        label: "Purpose",
        name: "purpose",
        description: "Used for",
      },
      capacity: {
        type: "Number",
        editable: true,
        label: "Capacity",
        name: "capacity",
        description:
          "Total volume of Dam, or maximum permitted capacity in m3 and litres",
      },
      currentVolume: {
        type: "Number",
        editable: true,
        label: "Current Volume",
        name: "currentVolume",
        description: "The total calculated volume of the Dam",
      },
      // diameter: { type: 'Number', editable: true, label: 'Diameter', name: 'diameter', description: 'Diameter of dam - metre.cm' },
      floorSize: {
        type: "Number",
        editable: true,
        label: "Floor Size",
        name: "floorSize",
        description: "Area of the floor of the Dam in m2",
      },
      topArea: {
        type: "Number",
        editable: true,
        label: "Top Area",
        name: "topArea",
        description: "Area of the top of the Dam in m2",
      },
      depth: {
        type: "Number",
        editable: true,
        label: "Depth/height (m)",
        name: "depth/Height",
        description: "Depth/ Height of Effluent Pond in m",
        required: true,
      },
      mountHeight: {
        type: "Number",
        editable: true,
        label: "Mount Height (m)",
        name: "Mount Height",
        description: "Mount Height of Effluent Pond in m",
        required: true,
      },
      surfaceWidth: {
        type: "Number",
        editable: true,
        label: "Surface Width (m)",
        name: "Surface Width",
        description: "Surface Width if rectangle",
        required: true,
      },
      bottomWidth: {
        type: "Number",
        editable: true,
        label: "Bottom Width (m)",
        name: "Bottom Width",
        description: "Bottom Width if rectangle",
        required: true,
      },
      surfaceLength: {
        type: "Number",
        editable: true,
        label: "Surface Length (m)",
        name: "Surface Length",
        description: "Length of recentangle",
        required: true,
      },
      bottomLength: {
        type: "Number",
        editable: true,
        label: "Bottom Length (m)",
        name: "Bottom Length",
        description: "Length of recentangle",
        required: true,
      },

      constructionMaterial: {
        type: "String",
        editable: true,
        label: "Construction material",
        name: "constructionMaterial",
        description: "Material dam is contructed from",
      },
      Location: {
        type: "RelatedType",
        editable: false,
        label: "Location",
        name: "Location",
        description: "Boundary points of dam",
        objectTypeId: "Location" as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: "Dam_has_Location",
      },
      image: {
        type: "String",
        editable: true,
        label: "Image",
        name: "image",
        description: "Photograph of dam",
      },
      comments: {
        type: "String",
        editable: true,
        label: "Comments",
        name: "comments",
        description: "Free text for info ",
      },
    };
  }
}
